import { useCallback, useEffect, useState } from 'react';

import type {
  TCalculationSummary,
  TCollaboratorRow,
  TUseHoursCalculationReturn,
} from '../../types';
import { MOCK_COLLABORATORS, MOCK_SUMMARY } from './mock-data';

const MOCK_LOADING_DELAY = 800;

type TUseHoursCalculationParams = {
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
};

export const useHoursCalculation = ({
  dateFrom,
  dateTo,
}: TUseHoursCalculationParams): TUseHoursCalculationReturn => {
  const [summary, setSummary] = useState<TCalculationSummary | undefined>(
    undefined,
  );
  const [collaborators, setCollaborators] = useState<TCollaboratorRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | undefined>(undefined);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(undefined);

    try {
      await new Promise(resolve => setTimeout(resolve, MOCK_LOADING_DELAY));

      if (!dateFrom || !dateTo) {
        setSummary(undefined);
        setCollaborators([]);

        return;
      }

      setSummary(MOCK_SUMMARY);
      setCollaborators(MOCK_COLLABORATORS);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Unknown error'));
    } finally {
      setLoading(false);
    }
  }, [dateFrom, dateTo]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    summary,
    collaborators,
    loading,
    error,
    refetch: fetchData,
    totalCount: collaborators.length,
  };
};
